import Image from "next/image";
import { useRouter } from "next/router";

import { Button } from "ui/Button";
import { useI18n } from "utils/with-i18n.utils";

export const CatalogBannerLegacy = () => {
  const { push } = useRouter();
  const i18n = useI18n();

  return (
    <div className="overflow-hidden relative p-10 pb-28 text-white bg-black rounded-md sm:py-16 sm:pb-32 md:pb-16">
        <h2 className="text-3xl font-semibold sm:text-4xl">
          {i18n.t('catalog.legacyBanner.title')}
        </h2>

        <p className="mt-1 mb-5 max-w-lg sm:text-lg text-md">
          {i18n.t('catalog.legacyBanner.subtitle')}
        </p>

        <Button alternative="white" className="w-full xs:w-auto" onClick={() => push("/smartphone/legacy")}>
          {i18n.t('catalog.legacyBanner.button')}
        </Button>

        <div className="aspect-square hidden absolute top-0 -right-24 w-[350px] h-full md:block lg:-right-40 xl:right-0">
          <Image src="/images/catalog/banner-legacy-desktop.webp" layout="fill" alt="smarphones" />
        </div>

        <div className="absolute bottom-0 left-0 w-full md:hidden">
          <div className="scale-125 -rotate-3 translate-y-1/3">
            <Image src="/images/catalog/banner-legacy-mobile.webp" width={850} height={200} alt="smarphones" />
          </div>
        </div>
    </div>
  );
};
